//@flow
import * as React from "react";
import "@nike/ruxac/styles/grid";
import { connect } from "react-redux";
import { openTable } from "../../data/modules/ui";
import TableNavLink from "./TableNavLink";
// import {SearchInput} from '@nike/ruxac';
import DownloadExcel from "../DownloadExcel/DownloadExcel";
import s from "./TableNav.less";

type Props = {
  openTable: Function
};

type State = {
  search: string
};

class TableNav extends React.Component<Props, State> {
  state = { search: "" };
  clearSearch = () => this.setState({ search: "" });
  changeSearch = e => this.setState({ search: e.target.value });
  render() {
    return (
      <div className={`${s.tableNav}`}>
        <div className={`${s.tableNavLeft}`}>
          <i className="g72-swoosh" />
          <div className={`${s.underline}`}>
            <TableNavLink name={"summary"}>
              <h4>Summary</h4>
            </TableNavLink>
            <TableNavLink name={"lineItems"}>
              <h4 onClick={() => this.props.openTable("Material")}>Material</h4>
            </TableNavLink>
            <TableNavLink name={"lineItems"}>
              <h4 onClick={() => this.props.openTable("Labor")}>Labor</h4>
            </TableNavLink>
            <TableNavLink name={"glossary"}>
              <h4>Glossary</h4>
            </TableNavLink>
          </div>
        </div>
        <div className={`${s.searchContainer}`}>
          <DownloadExcel />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { openTable };
export default connect(null, mapDispatchToProps)(TableNav);



// WEBPACK FOOTER //
// ./src/components/Navigation/TableNav.js